export default {
  textColor: "#202124",
  borderColor: "#e0e0e0",
  backgroundColor: "#fff",
  offTextColor: "#5f6368",
  secondaryTextColor: "#80868b"
};
